import React from 'react';
import Svg, { Path } from 'react-native-svg';
import { Props } from '../../../shared/assets/SvgProps';

import Typography from '@shared/constants/Typography';

const LanguageIcon: React.FC<Props> = ({
  width: _width = Typography.width.width20,
  height: _height = Typography.height.height20,
  color = '#FFFFFF',
}) => {
  return (
    <Svg width={_width} height={_height} viewBox="0 0 20 20" fill="none">
      <Path
        d="M1.6665 10H18.3332M1.6665 10C1.6665 14.6024 5.39746 18.3334 9.99984 18.3334M1.6665 10C1.6665 5.39765 5.39746 1.66669 9.99984 1.66669M18.3332 10C18.3332 14.6024 14.6022 18.3334 9.99984 18.3334M18.3332 10C18.3332 5.39765 14.6022 1.66669 9.99984 1.66669M9.99984 1.66669C12.0842 3.94865 13.2688 6.91005 13.3332 10C13.2688 13.09 12.0842 16.0514 9.99984 18.3334M9.99984 1.66669C7.91544 3.94865 6.73088 6.91005 6.6665 10C6.73088 13.09 7.91544 16.0514 9.99984 18.3334"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Svg>
  );
};

export default LanguageIcon;
